<template>
    <div class="zoezi-card-default" style="box-shadow: 0 2px 8px rgba(0,0,0,0.12)">
        <div class="zoezi-card-horizontal" style="flex-wrap: nowrap">
            <div class="z-card-image" style="position: relative; background-size: 70%; background-position: center; background-repeat: no-repeat; background-color: white; border-radius: 8px" :style="{'background-image': 'url(' + (firstImagekey ? $api.getImageUrl(firstImagekey, 100) : $api.getAssetUrl('/assets/img/cash.png')) + ')' }">
                <v-chip v-if="item.items && item.items.length > 1" x-small color="primary" text-color="white" style="position: absolute; top: 4px; left: 4px">+{{item.items.length - 1}}</v-chip>
            </div>
            <div class="z-card-content" style="cursor: pointer; min-width: 0; white-space: normal" @click="onContentClick">
                <strong class="text-subtitle-1 font-weight-bold">{{item.name}}</strong>
                <div v-if="item.created" style="font-size: 11px" class="grey--text">{{$translate('Created')}}: {{Date.formatFullShorter(item.created)}}</div>
                <slot name="date-line"></slot>
                <div style="font-size: 11px" class="grey--text mt-3 d-flex align-center">
                    {{item.items && item.items.length ? item.items.length : 1}} {{item.items && item.items.length > 1 ? $translate('products') : $translate('product')}}
                    <v-icon v-if="expandable" x-small class="ml-1">{{expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                </div>
                <withdrawal-status v-if="withdrawalSummary" :text="withdrawalSummary" />
                <div class="text-subtitle-1 font-weight-bold">
                    <slot name="amount">{{item.amount | price}}</slot>
                </div>
            </div>
            <div class="z-card-action pt-2 px-2 d-flex flex-column align-end justify-space-between" style="flex-shrink: 0">
                <slot name="actions"></slot>
            </div>
        </div>
        <v-expand-transition>
            <div v-if="expanded && item.items && item.items.length >= 1 && expandable" style="padding: 8px 12px">
                <v-divider class="mb-2" />
                <div class="d-flex align-center py-1" style="font-size: 11px">
                    <span class="grey--text flex-grow-1">{{$translate('Product')}}</span>
                    <span class="grey--text flex-shrink-0 ml-2" style="min-width: 60px; text-align: right">{{$translate('Discount')}}</span>
                    <span class="grey--text flex-shrink-0 ml-2" style="min-width: 60px; text-align: right">{{$translate('Sum')}}</span>
                </div>
                <div v-for="(product, index) in item.items" :key="index">
                    <v-divider v-if="index > 0" class="my-1" />
                    <div class="d-flex align-center py-1" style="font-size: 12px" :style="product.included ? 'padding-left: 16px; border-left: 2px solid #e0e0e0' : ''">
                        <v-img v-if="product.imagekey" :src="$api.getImageUrl(product.imagekey, 40)" max-width="30" max-height="30" class="rounded flex-shrink-0 mr-2" contain />
                        <div class="flex-grow-1">
                            <span class="grey--text text--darken-2">{{product.name}}</span>
                            <withdrawal-status v-if="product.withdrawalRequest" :text="withdrawalRequestText(product.withdrawalRequest)" />
                        </div>
                        <span class="red--text flex-shrink-0 ml-2" style="min-width: 60px; text-align: right">{{product.discount > 0 ? ('-' + $options.filters.price(product.discount)) : ''}}</span>
                        <span class="flex-shrink-0 ml-2" :class="product.hide_price ? 'grey--text font-italic' : 'font-weight-bold'" style="min-width: 60px; text-align: right">{{product.hide_price ? $translate('Included') : $options.filters.price(product.amount)}}</span>
                    </div>
                </div>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import { withdrawalRequestText } from '../util';
import WithdrawalStatus from './WithdrawalStatus.vue';
export default {
    name: 'payment-card',

    components: { WithdrawalStatus },

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        expanded: false
    }),

    computed: {
        firstImagekey() {
            return this.item.imagekey || (this.item.items && this.item.items.find(i => i.imagekey)?.imagekey);
        },
        hasDiscount() {
            return this.item.items && this.item.items.some(i => i.discount > 0);
        },
        expandable() {
            return (this.item.items && this.item.items.length > 1) || this.hasDiscount;
        },
        // On the card itself, beside its buttons, so a customer about to pay sees what has been
        // withdrawn without expanding the card. Products included in a package are withdrawn
        // with their main product, thus they are not counted.
        withdrawalSummary() {
            const products = (this.item.items || []).filter(product => !product.included);
            const requests = products.map(product => product.withdrawalRequest).filter(Boolean);
            if (!requests.length) {
                return null;
            }
            const days = new Set(requests.map(withdrawalRequest => Date.formatFullShorterYear(withdrawalRequest.created)));
            if (requests.length == products.length && days.size == 1) {
                return withdrawalRequestText(requests[0]);
            }

            return this.$translate('Withdrawal request sent for {0} of {1} products').format(requests.length, products.length);
        }
    },

    methods: {
        withdrawalRequestText,
        onContentClick() {
            if (this.expandable) {
                this.expanded = !this.expanded;
            } else {
                this.$emit('content-click');
            }
        }
    }
}
</script>
